var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('googlemaps-map',{attrs:{"center":_vm.map.pos_munera,"zoom":_vm.map.zoom,"map-type-id":"terrain","options":_vm.map.options}},[_c('googlemaps-marker',{attrs:{"position":_vm.map.pos}}),_vm._v(" "),_c('googlemaps-marker',{attrs:{"position":_vm.map.pos_munera}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3f8b339f","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/parts/mapa.vue
// module id = null
// module chunks = 